var BaseElement = {
  type: "simple",
  visible: "a",
  content: {},
  mobile: {
    w: 0,
    h: 0,
    x: 0,
    y: 0,
    a: 0,
  },
  desktop: {
    w: 0,
    h: 0,
    x: 0,
    y: 0,
    a: 0,
  },
};

export default BaseElement;
